export default function pluralFilter(text) {
  //Type checking to avoid non-strings
  if (typeof text !== 'string') return text;

  return text + 's';
}
